import { render, staticRenderFns } from "./DragDropContainer.vue?vue&type=template&id=5f71ed0b"
import script from "./DragDropContainer.vue?vue&type=script&lang=js"
export * from "./DragDropContainer.vue?vue&type=script&lang=js"
import style0 from "./DragDropContainer.vue?vue&type=style&index=0&id=5f71ed0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports